module.exports = __webpack_public_path__ + "img/profile.017b1622.svg";